import { render } from "./ExamplesCollection.vue?vue&type=template&id=a46c8ed2&ts=true"
import script from "./ExamplesCollection.vue?vue&type=script&lang=ts"
export * from "./ExamplesCollection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__